import { userPaths } from 'routes/constants/userPaths';

import { Navigate, Outlet } from 'react-router-dom';

import { useEndUserDashboardAccess } from 'hooks/useEndUserDashboardAccess';

/** Blocks HSA paydays, expenses, confirm-cashback, etc. until connected with expenses. */
const EndUserFullFlowRoute = () => {
  const { isLoading, canAccessFullFlows } = useEndUserDashboardAccess();

  if (isLoading) {
    return null;
  }

  if (!canAccessFullFlows) {
    return <Navigate to={userPaths.endUser} replace />;
  }

  return <Outlet />;
};

export default EndUserFullFlowRoute;
